export default __webpack_public_path__ + "dist/media/PencilGrey.f4942b43.svg";